import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from "@mui/material";
export const UiLink = (props) => _jsx(Link, Object.assign({}, props));
//# sourceMappingURL=ui_link.js.map